import { realtime as realtimeApi } from 'gipsy-api'
import { realtime as RealTime } from 'gipsy-misc'

export default new RealTime(realtimeApi.get)
